"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskEmail = exports.decryptString = exports.encryptString = void 0;
function encryptString(input, secretKey) {
    let encryptedString = '';
    for (let i = 0; i < input.length; i++) {
        const charCode = input.charCodeAt(i);
        const keyChar = secretKey.charCodeAt(i % secretKey.length);
        const encryptedCharCode = (charCode + keyChar) % 256; // 256 represents the ASCII range
        encryptedString += String.fromCharCode(encryptedCharCode);
    }
    return encryptedString;
}
exports.encryptString = encryptString;
function decryptString(input, secretKey) {
    let decryptedString = '';
    for (let i = 0; i < input.length; i++) {
        const charCode = input.charCodeAt(i);
        const keyChar = secretKey.charCodeAt(i % secretKey.length);
        const decryptedCharCode = (charCode - keyChar + 256) % 256; // 256 represents the ASCII range
        decryptedString += String.fromCharCode(decryptedCharCode);
    }
    return decryptedString;
}
exports.decryptString = decryptString;
function maskEmail(text, secretKey) {
    const emailRegex = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
    const maskedText = text.replace(emailRegex, (match) => {
        const encryptedEmail = encryptString(match, secretKey);
        return `***${encryptedEmail}***`;
    });
    return maskedText;
}
exports.maskEmail = maskEmail;
